<template>
  <UIDialog :is-open :z-index size="3md" :title @close="handleClose">
    <div v-if="$slots.loading" class="wizzard__loading">
      <UIPreloader />
      <div class="wizzard__loading-text">
        <slot name="loading" />
      </div>
    </div>
    <template v-else>
      <slot name="top" />
      <div class="wizzard">
        <div class="wizzard__sidebar">
          <UIStepsNavigation
            v-model="currentStep"
            v-bind="{ shrink, steps }"
          />
        </div>
        <slot />
      </div>
    </template>
    <template v-if="!$slots.loading" #footer>
      <slot name="buttons" />
    </template>
  </UIDialog>
</template>

<script setup lang="ts">
import { StepsNavigation } from '@types'

import { UIPreloader, UIStepsNavigation } from '@ui/core'
import { UIDialog } from '@ui/modals'

type Props = {
  title: string
  isOpen: boolean
  zIndex: number
  steps: StepsNavigation[]
  shrink?: boolean
}

type Emits = {
  close: []
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const currentStep = defineModel<number>({ default: 0 })

const handleClose = () => {
  emit('close')
}
</script>

<style>
.wizzard {
  @apply flex flex-col md:flex-row;
  @apply gap-4;

  &__sidebar {
    @apply md:w-[31.5%];
    @apply shrink-0;
  }

  &__form {
    @apply flex flex-col flex-auto;
    @apply gap-6 md:gap-8;
  }

  &__summary {
    @apply flex flex-col;
    @apply gap-3;
  }

  &__summary-title {
    @apply font-medium text-gray-600;
  }

  &__loading {
    @apply min-h-56;
    @apply flex items-center justify-center;
    @apply gap-4;
  }
}
</style>
